export const catalogTabs = {
  Chart: { id: 1, type: 'Chart', icon: 'chart.svg', label: 'Диаграммы' },
  Table: { id: 2, type: 'Table', icon: 'table.svg', label: 'Таблицы' },
  Other: { id: 3, type: 'Other', icon: 'paper.svg', label: 'Другие' }
};
